"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreFollowedIdMapReducers = void 0;
const add_1 = require("./add.js");
const redux_1 = require("redux");
const state_1 = require("./state.js");
const xuder_1 = require("@sonar-software/xuder");
const remove_1 = require("./remove.js");
exports.coreFollowedIdMapReducers = (0, redux_1.combineReducers)({
    read: (0, xuder_1.joinSyncReducers)([
        add_1.addCoreFollowedIdMapSlice.syncReducer,
        remove_1.removeCoreFollowedIdMapSlice.syncReducer
    ], state_1.defaultFollowedIdMapState)
});
//# sourceMappingURL=index.js.map